export default __webpack_public_path__ + "static/media/original-bottle-svg.147ede7f.svg";